<template>
    <div>
        <b-row>
            <b-col cols="4">
                <b-form-group :label="$t('student_number')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.number) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group :label="$t('name_surname')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.name) + ' ' + isNotNullValue(form.surname) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group :label="$t('subject')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.subject) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group :label="$t('amount')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.amount) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group :label="$t('currency')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.currency) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group :label="$t('due_date')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.due_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group :label="$t('amount_paid')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.paid_amount) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
<!--            <b-col cols="4">
                <b-form-group :label="$t('flight_information')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.flight_information) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>-->
<!--                <b-col cols="4">
                    <b-form-group :label="$t('invoice_number')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.invoice_number) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>        -->    <!--<b-col cols="4">
                <b-form-group :label="$t('invoice_amount')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.invoice_amount) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>-->
        </b-row>
        <datatable :isLoading.sync="datatable.isLoading"
                   :columns="datatable.columns"
                   :rows="datatable.rows"
                   :total="datatable.total"
                   :queryParams="datatable.queryParams"
                   :lineNumbers="false"
                   @on-page-change="onPageChange"
                   @on-sort-change="onSortChange"
                   @on-per-page-change="onPerPageChange"
                   v-show="datatable.showTable"
        >
        </datatable>
        <CommonModal ref="updateFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('pilotagepayment_update')">
            <template v-slot:CommonModalTitle>
                {{ $t('update').toLocaleUpperCase('tr-TR') }}
            </template>
            <template v-slot:CommonModalContent>
                <update-payment-form :formId="formItemId"
                                  @updatePaymentFormSuccess="updatePaymentFormSuccess"
                                  v-if="formProcess=='updatePayment'"/>
            </template>
        </CommonModal>
    </div>
</template>

<script>
    //Service
    import PilotagePaymentsService from '@/services/PilotagePaymentsService';

    //Component
    import Datatable from '@/components/datatable/Datatable';
    import qs from "qs";
    import PilotagePaymentDetailService from "@/services/PilotagePaymentDetailService";

    // Pages
    import UpdatePaymentForm from "./UpdatePaymentForm";
    import AnnouncementsService from "@/services/AnnouncementsService";

    export default {
        props: {
            formId: {
                type: Number
            }
        },
        components: {
            Datatable,
            UpdatePaymentForm,
        },
        data() {
            return {
                form: {
                    code: null,
                    name: null,
                },
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            sortable: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('edit'),
                                    class: 'ri-edit-box-line',
                                    permission: "virtualpos_update",
                                    callback: (row) => {
                                        this.updateFormShow(row.id)
                                    }
                                },
                                {
                                    text: this.$t('download'),
                                    permission:'proformainvoice_download',
                                    class: 'ri-download-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.download(row)
                                    },
                                    show: function (row) {
                                        if(row.file){
                                            return true;
                                        }
                                        return false;
                                    }
                                },
                                {
                                    text: this.$t('delete'),
                                    permission: 'announcement_delete',
                                    class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                    callback: (row) => {
                                        this.formDelete(row.id)
                                    }
                                }

                            ]
                        },
                        {
                            label: this.$t('payment_date'),
                            field: 'payment_date',
                            sortable: true,
                        },
                        {
                            label: this.$t('amount'),
                            field: 'amount',
                            sortable: true,
                        },
                        {
                            label: this.$t('invoice_number'),
                            field: 'invoice_number',
                            sortable: true,
                            formatFn: (value) => {
                                return value && value !== 'null' ? value : ''
                            }
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: false,
                    showTable: true,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    },
                },
                formProcess: null,
                formItemId: null
            }
        },
        async created() {
            await this.get()
            await this.getRows()
        },
        methods: {
            formClear() {
                this.formItemId = null
                this.formProcess = null
            },
            get() {
                this.formLoading = true;
                PilotagePaymentsService.get(this.formId)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.formLoading = false;
                                })
                                .catch((error) => {
                                    this.showErrors(error)
                                });
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                let config = {
                    params: {
                        limit: -1,
                        filter: {
                            pilotage_payment_id: this.formId
                        },
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                };

                return PilotagePaymentDetailService.getAll(config)
                    .then((response) => {
                        this.datatable.rows = response.data.data
                        this.datatable.total = response.data.pagination.total
                    })
                    .finally(() => {
                        this.datatable.isLoading = false;
                    });
            },
            updateFormShow(id) {
                this.formItemId = id
                this.formProcess = 'updatePayment'
                this.$refs.updateFormModal.$refs.commonModal.show()
            },
            async updatePaymentFormSuccess() {
                this.$refs.updateFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            download(row) {
                if (this.checkPermission('pilotagepaymentdetail_download')) {
                    PilotagePaymentDetailService.download(row.id).then(response=>{
                        this._downloadFile(response, row.file.file_name)
                    })
                } else {
                    this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
                }
            },
            formDelete(id) {
                this.$swal
                    .fire({
                        text: this.$t('are_you_sure_to_delete'),
                        showCancelButton: true,
                        confirmButtonText: this.$t('yes'),
                        cancelButtonText: this.$t('no')
                    })
                    .then((result) => {
                        if (result.isConfirmed) {
                            PilotagePaymentDetailService.del(id)
                                .then(response => {
                                    this.$toast.success(this.$t('api.' + response.data.message));
                                    this.getRows();
                                    this.formClear();
                                })
                                .catch(error => {
                                    this.$toast.error(this.$t('api.' + error.data.message));
                                });
                        }
                    })
            },
        }
    }
</script>
